import { APICore } from './apiCore'

const api = new APICore()

function getCategoriasRuta (params) {
  const baseUrl = '/categorias-ruta'
  return api.get(baseUrl, params)
}

function getCategoriaRuta (id) {
  const baseUrl = `/categorias-ruta/${id}`
  return api.get(baseUrl, {})
}

function addCategoriaRuta (params) {
  const baseUrl = '/categorias-ruta'
  return api.createWithFile(baseUrl, params)
}

function updateCategoriaRuta (params) {
  const baseUrl = '/categorias-ruta'
  return api.updateWithFile(baseUrl, params)
}

function deleteCategoriaRuta (params) {
  const baseUrl = '/categorias-ruta'
  return api.delete(baseUrl, params)
}

export { getCategoriasRuta, getCategoriaRuta, addCategoriaRuta, updateCategoriaRuta, deleteCategoriaRuta }
